export default __webpack_public_path__ + "static/media/125.c4bcfd62.png";